module.exports = __webpack_public_path__ + "img/coding.e25b481b.png";